import React, { useCallback, useState, useEffect } from "react";
import { useIntl, defineMessages } from "react-intl";
import Link from "theme/components/atoms/Typography/Link";
import { useHistory } from "react-router";
import useDifferedClick from "theme/layouts/Header/Navigation/AccountNavigation/useDifferedClick";
import Button from "theme/components/atoms/Button/Button";
import Skeleton from "theme/components/atoms/Skeleton/Skeleton";
import Svg from "theme/components/atoms/Icon/Svg";
const loginPath = {
  pathname: "/login",
  state: { modal: true },
};

const messages = defineMessages({
  account: {
    id: "layouts.Header.Navigation.account",
    defaultMessage: "My Account",
  },
  loading: {
    id: "layouts.Header.Navigation.loading",
    defaultMessage: "Loading user information...",
  },
  signin: {
    id: "layouts.Header.Navigation.signin",
    defaultMessage: "Sign in",
  },
});

const AccountIcon = ({ loading, user, onUserMenu }) => {
  const intl = useIntl();

  const history = useHistory();

  const [isLoading, setIsLoading] = useState(false);
  const [isClicked, onLoadingClick] = useDifferedClick(
    loading,
    useCallback(() => {
      if (!user) {
        return false;
      }

      if (user.id) {
        onUserMenu();
      } else {
        history.push(loginPath);
      }
    }, [user, history, onUserMenu])
  );

  useEffect(() => {
    if (loading) {
      setIsLoading(true);
    }
  }, [loading]);

  return loading ? (
    <Skeleton isLoaded={!isLoading} width="full">
      <Button
        type="button"
        aria-label={intl.formatMessage(messages.loading)}
        onClick={() => {
          onLoadingClick(true);
        }}
        state={isClicked ? "pending" : undefined}
        appearance="icon-header"
      >
        <Svg type="account_circle" />
      </Button>
    </Skeleton>
  ) : user?.id ? (
    <Skeleton isLoaded={!loading} width="full">
      <Button
        type="button"
        aria-label={intl.formatMessage(messages.account)}
        onClick={() => onUserMenu()}
        appearance="icon-header"
      >
        <Svg type="account_circle" />
      </Button>
    </Skeleton>
  ) : (
    <Skeleton isLoaded={!loading} width="full">
      <Link
        to={loginPath}
        buttonAppearance="icon-header"
        aria-label={intl.formatMessage(messages.account)}
      >
        <Svg type="account_circle" />
      </Link>
    </Skeleton>
  );
};

export default AccountIcon;
